// GAPI getters
export default {
  get_gapi: (state) => state,
};
